import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        //首页 - 可分享
        {
            path: '/',
            name: "home",
            component: function(resolve) {
                require(['@/view/home/home'], resolve)
            },
        },
        //问答 - 可分享
        {
            path: '/questions',
            name: "questions",
            component: function(resolve) {
                require(['@/view/questions/questions'], resolve)
            },
        },
        //美购 - 可分享
        {
            path: '/shopping',
            name: "shopping",
            component: function(resolve) {
                require(['@/view/shopping/shopping'], resolve)
            },
        },
        //我的
        {
            path: '/personal',
            name: "personal",
            component: function(resolve) {
                require(['@/view/personal/personal'], resolve)
            },
        },
        //登陆
        {
            path: '/login',
            name: "login",
            component: function(resolve) {
                require(['@/view/home/components/login/login'], resolve)
            },
        },
        //问答 - 可分享
        {
            path: '/question',
            name: "question",
            component: function(resolve) {
                require(['@/view/home/components/question/question'], resolve)
            },
        },
        //投诉
        {
            path: '/complaints',
            name: "complaints",
            component: function(resolve) {
                require(['@/view/home/components/complaints/complaints'], resolve)
            },
        },
        //地址列表
        {
            path: '/information',
            name: "information",
            meta: {
                keepAlive: false
            },
            component: function(resolve) {
                require(['@/view/personal/components/information/information'], resolve)
            },
        },
        //添加地址
        {
            path: '/addAddress',
            name: "addAddress",
            component: function(resolve) {
                require(['@/view/personal/components/addAddress/addAddress'], resolve)
            },
        },
        //商品详情 - 可分享
        {
            path: '/goodsDetails',
            name: "goodsDetails",
            component: function(resolve) {
                require(['@/view/shopping/components/goodsDetails/goodsDetails'], resolve)
            },
        },
        //购物车
        {
            path: '/cart',
            name: "cart",
            component: function(resolve) {
                require(['@/view/shopping/components/cart/cart'], resolve)
            },
        },
        //专家 - 可分享
        {
            path: '/expert',
            name: "expert",
            component: function(resolve) {
                require(['@/view/home/components/expert/expert'], resolve)
            },
        },
        //拼团 - 可分享
        {
            path: '/assemble',
            name: "assemble",
            component: function(resolve) {
                require(['@/view/personal/components/assemble/assemble'], resolve)
            },
        },
        //专家详情 - 可分享
        {
            path: '/expertDetails',
            name: "expertDetails",
            component: function(resolve) {
                require(['@/view/home/components/expert/components/expertDetails/expertDetails'], resolve)
            },
        },
        //美丽日记 - 可分享
        {
            path: '/diary',
            name: "diary",
            component: function(resolve) {
                require(['@/view/home/components/diary/diary'], resolve)
            },
        },
        //签到
        {
            path: '/sign',
            name: "sign",
            component: function(resolve) {
                require(['@/view/home/components/sign/sign'], resolve)
            },
        },
        //订单
        {
            path: '/order',
            name: "order",
            meta: {
                keepAlive: false
            },
            component: function(resolve) {
                require(['@/view/shopping/components/order/order'], resolve)
            }
        },
        //我的提问
        {
            path: '/iquestions',
            name: "iquestions",
            component: function(resolve) {
                require(['@/view/personal/components/questions/questions'], resolve)
            }
        },
        //提问详情 - 可分享
        {
            path: '/answerDetails',
            name: "answerDetails",
            component: function(resolve) {
                require(['@/view/questions/components/answerDetails/answerDetails'], resolve)
            }
        },
        //日记详情 - 可分享
        {
            path: '/diaryDetails',
            name: "diaryDetails",
            component: function(resolve) {
                require(['@/view/home/components/diary/components/diaryDetails/diaryDetails'], resolve)
            }
        },
        // //订单列表
        // {
        //     path: '/orderList',
        //     name: "orderList",
        //     component: function(resolve) {
        //         require(['@/view/personal/components/orderList/orderList'], resolve)
        //     }
        // },
        //已支付详情
        {
            path: '/orderList/paidDetails',
            name: "paidDetails",
            component: function(resolve) {
                require(['@/view/personal/components/orderList/components/components/paidDetails'], resolve)
            }
        },
        //未支付详情
        {
            path: '/orderList/unpaidDetails',
            name: "unpaidDetails",
            component: function(resolve) {
                require(['@/view/personal/components/orderList/components/components/unpaidDetails'], resolve)
            }
        },
        //拼团详情 - 可分享
        {
            path: '/groupDetails',
            name: "groupDetails",
            component: function(resolve) {
                require(['@/view/personal/components/assemble/components/groupDetails'], resolve)
            }
        },
        //写日记->添加日记本
        {
            path: '/writeDiary',
            name: "writeDiary",
            component: function(resolve) {
                require(['@/view/home/components/writeDiary/writeDiary'], resolve)
            }
        },
        //写日记->添加日记
        {
            path: '/addDiary',
            name: "addDiary",
            component: function(resolve) {
                require(['@/view/home/components/writeDiary/components/addDiary'], resolve)
            }
        },
        //我的预约
        {
            path: '/preAbout',
            name: "preAbout",
            component: function(resolve) {
                require(['@/view/personal/components/preAbout/preAbout'], resolve)
            }
        },
        //我的赠品
        {
            path: '/gift',
            name: "gift",
            component: function(resolve) {
                require(['@/view/personal/components/gift/gift'], resolve)
            }
        },
        //我的卡劵
        {
            path: '/coupon',
            name: "coupon",
            component: function(resolve) {
                require(['@/view/personal/components/coupon/coupon'], resolve)
            }
        },
        //维密福利
        {
            path: '/welfare',
            name: "welfare",
            component: function(resolve) {
                require(['@/view/home/components/welfare/welfare'], resolve)
            }
        },
        //领券->转赠券详情
        {
            path: '/receiveCoupon',
            name: "receiveCoupon",
            component: function(resolve) {
                require(['@/view/personal/components/coupon/receiveCoupon'], resolve)
            }
        },
        //转赠->转赠券详情
        {
            path: '/transferCoupon',
            name: "transferCoupon",
            component: function(resolve) {
                require(['@/view/personal/components/coupon/transferCoupon'], resolve)
            }
        },
        //积分商城
        {
            path: '/integralGoods',
            name: "integralGoods",
            component: function(resolve) {
                require(['@/view/home/components/IntegralGoods/IntegralGoods'], resolve)
            }
        },
        //积分商品详情
        {
            path: '/IntegralGoodsDetails',
            name: "IntegralGoodsDetails",
            component: function(resolve) {
                require(['@/view/home/components/IntegralGoods/components/IntegralGoodsDetails'], resolve)
            }
        },
        //用户积分信息  
        {
            path: '/userIntegrationInfo',
            name: "userIntegrationInfo",
            component: function(resolve) {
                require(['@/view/personal/components/userIntegrationInfo/userIntegrationInfo'], resolve)
            }
        },
        //用户积分信息 线下
        {
            path: '/userIntegrationInfoUnder',
            name: "userIntegrationInfoUnder",
            component: function(resolve) {
                require(['@/view/personal/components/userIntegrationInfo/userIntegrationInfoUnder'], resolve)
            }
        },
        //其他
        {
            path: '/one',
            name: "one",
            component: function(resolve) {
                require(['@/components/one'], resolve)
            }
        },
        //其他
        {
            path: '/cs',
            name: "cs",
            component: function(resolve) {
                require(['@/components/cs'], resolve)
            }
        },
        //领券页面
        {
            path: '/cashCoupon',
            name: "cashCoupon",
            component: function(resolve) {
                require(['@/view/personal/components/cashCoupon/cashCoupon'], resolve)
            }
        },
        //个人二维码 - 点击链接
        {
            path: '/personalQrcode',
            name: "personalQrcode",
            component: function(resolve) {
                require(['@/view/personal/components/personalQrcode/personalQrcode'], resolve)
            }
        },
        //抽奖券
        {
            path: '/raffleTickets',
            name: "raffleTickets",
            component: function(resolve) {
                require(['@/view/personal/components/raffleTickets/raffleTickets'], resolve)
            }
        },
        //咨询记录单
        {
            path: '/record',
            name: "record",
            component: function(resolve) {
                require(['@/view/personal/components/record/record'], resolve)
            }
        },
        //体验券
        {
            path: '/experienceCoupon',
            name: "experienceCoupon",
            component: function(resolve) {
                require(['@/view/personal/components/experienceCoupon/experienceCoupon'], resolve)
            }
        },
        //案例报名
        {
            path: '/caseRegistration',
            name: "caseRegistration",
            component: function(resolve) {
                require(['@/view/personal/components/caseRegistration/caseRegistration'], resolve)
            }
        },
        //活动中间层
        {
            path: '/activityMiddleLayer',
            name: "activityMiddleLayer",
            component: function(resolve) {
                require(['@/view/personal/components/activityMiddleLayer/activityMiddleLayer'], resolve)
            }
        },
        //支付成功
        {
            path: '/paymentSuccess',
            name: "paymentSuccess",
            component: function(resolve) {
                require(['@/components/paymentSuccess'], resolve)
            }
        },
        //订单列表
        {
            path: '/orderList',
            name: "orderList",
            component: function(resolve) {
                require(['@/view/personal/components/orderList/orderList'], resolve)
            },
            children: [
                //全部
                {
                    path: '',
                    name: "whole",
                    component: function(resolve) {
                        require(['@/view/personal/components/orderList/components/whole'], resolve)
                    }
                },
                //已付款
                {
                    path: '/paid',
                    name: "paid",
                    component: function(resolve) {
                        require(['@/view/personal/components/orderList/components/paid'], resolve)
                    }
                },
                //未付款
                {
                    path: '/unpaid',
                    name: "unpaid",
                    component: function(resolve) {
                        require(['@/view/personal/components/orderList/components/unpaid'], resolve)
                    }
                },
                //已核销
                {
                    path: '/cancelled',
                    name: "cancelled",
                    component: function(resolve) {
                        require(['@/view/personal/components/orderList/components/alreadyWriteOff'], resolve)
                    }
                }
            ]
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js